import axios from './axios'

export const getSessionAlerts = data =>
  axios.get(`/session_alert`)

export const getTemplateData = person_id =>
  axios.get(`/session_alert/template-data?person_id=${person_id}`)

export const sendSessionAlertEmail = data =>
  axios.post(`/session_alert/send_email`, data)
